// Module
var code = "<customer-contacts\n  customer-id=\"vm.customer.id\"\n  customer-name=\"vm.customer.name\"\n>\n</customer-contacts>\n";
// Exports
module.exports = code;